import { Routes } from "@angular/router";
import { LandingComponent } from "./pages/landing/landing.component";
import { LandingCustomerMainComponent } from "./pages/landing/customer/main/main.component";
import { LandingWhyUsComponent } from "./pages/landing/customer/why-us/why-us.component";
import { LandingBusinessMainComponent } from "./pages/landing/business/main/main.component";
import { LandingBusinessPricingComponent } from "./pages/landing/business/pricing/pricing.component";
import { LandingBusinessBlogComponent } from "./pages/landing/business/blog/blog.component";
import { LandingBusinessBlogPostComponent } from "./pages/landing/business/blog-post/blog-post.component";
import { CustomerSignUpComponent } from "./pages/customer/sign-up/sign-up.component";
import { CustomerLoginComponent } from "./pages/customer/login/login.component";
// import { CustomeResetPasswordComponent } from "./pages/customer/reset-password/reset-password.component";
import { CustomerComponent } from "./pages/customer/customer.component";
import { CustomerOverviewComponent } from "./pages/customer/overview/overview.component";
import { CustomerAppointmentsComponent } from "./pages/customer/appointments/appointments.component";
import { CustomerFavoritesComponent } from "./pages/customer/favorites/favorites.component";
import { CustomerAppointmentDetailsComponent } from "./pages/customer/appointments/details/details.component";
import { CustomerPromoCodesComponent } from "./pages/customer/promo-codes/promo-codes.component";
import { CustomerAccountSettingsComponent } from "./pages/customer/account-settings/account-settings.component";
import { BusinessRequestDemoComponent } from "./pages/business/request-demo/request-demo.component";
import { BusinessComponent } from "./pages/business/business.component";
import { BusinessLoginComponent } from "./pages/business/login/business-login.component";
import { BusinessOnboardingComponent } from "./pages/business/onboarding/onboarding.component";
import { SuccessComponent } from "./shared/components/success/success.component";
import { BusinessOverviewComponent } from "./pages/business/overview/overview.component";
import { BusinessSalesFinancesComponent } from "./pages/business/sales-finances/sales-finances.component";
import { BusinessCustomerRelationshipComponent } from "./pages/business/customer-relationship/customer-relationship.component";
import { BusinessEmployeeManagementComponent } from "./pages/business/employee-management/employee-management.component";
import { BusinessPromotionComponent } from "./pages/business/promotion/promotion.component";
import { BusinessAccountStoreSettingsComponent } from "./pages/business/account-store-settings/account-store-settings.component";
import { StaffOverviewComponent } from "./pages/staff/overview/overview.component";
import { StaffAppointmentsComponent } from "./pages/staff/appointments/appointments.component";
import { StaffServicesComponent } from "./pages/staff/services/services.component";
import { StaffCustomerRelationshipComponent } from "./pages/staff/customer-relationship/customer-relationship.component";
import { StaffComponent } from "./pages/staff/staff.component";
import { BusinessAppointmentsComponent } from "./pages/business/appointments/appointments.component";
import { BusinessAppointmentAddComponent } from "./pages/staff/appointment-add/appointment-add.component";
import { CustomerSalonDetailsComponent } from "./pages/landing/customer/salon-details/salon-details.component";
import { ExploreComponent } from "./pages/landing/shared/explore/explore.component";
import { SearchComponent } from "./pages/landing/shared/search/search.component";
import { SalonsComponent } from "./pages/business/saloons/saloons.component";
import { BusinessServicesMainComponent } from "./pages/business/services/services.component";
import { BusinessServiceCreateComponent } from "./pages/business/services/create/create.component";
import { NotFoundPageComponent } from "./pages/landing/not-found-page/not-found-page/not-found-page.component";

import { AddEmployeeComponent } from "./pages/business/add-employee/add-employee.component";
import { AddSalonFormComponent } from "./pages/business/add-salon/add-salon.component";

// Import AuthGuard
import { AuthGuard } from "./auth-guard"; // Update path as needed
import { VerifyOtpComponent } from "./pages/landing/verify-otp-page/verify-otp-page.component";
import { FaqComponent } from "./pages/landing/customer/faq/faq.component";
import { ContactComponent } from "./pages/landing/customer/contact/contact.component";

import { CustomerAppointmentModifyComponent } from "./pages/customer/appointments/modify/modify.component";

import { SupportComponent } from "./pages/landing/customer/support/support.component";

export const routes: Routes = [
  {
    path: "",
    component: LandingComponent,
    data: { public: true },
    children: [
      {
        path: "",
        component: LandingCustomerMainComponent,
        data: { public: true },
      },
    ],
  },
  // These routes stay EXACTLY the same - no auth needed
  {
    path: "customer",
    component: LandingComponent,
    data: { public: true },
    children: [
      {
        path: "",
        component: LandingCustomerMainComponent,
        data: { public: true },
      },
      {
        path: "why-us",
        component: LandingWhyUsComponent,
        data: { public: true },
      },
      {
        path: "salon/:id",
        component: CustomerSalonDetailsComponent,
        data: { public: true },
      },
      { path: "explore", component: ExploreComponent, data: { public: true } },
      { path: "search", component: SearchComponent, data: { public: true } },
    ],
  },
  {
    path: "business",
    component: LandingComponent,
    data: { public: true },
    children: [
      {
        path: "",
        component: LandingBusinessMainComponent,
        data: { public: true },
      },
      {
        path: "pricing",
        component: LandingBusinessPricingComponent,
        data: { public: true },
      },
      {
        path: "blog",
        component: LandingBusinessBlogComponent,
        data: { public: true },
      },
      {
        path: "post",
        component: LandingBusinessBlogPostComponent,
        data: { public: true },
      },
      { path: "explore", component: ExploreComponent, data: { public: true } },
      { path: "search", component: SearchComponent, data: { public: true } },
    ],
  },
  // UPDATED: Add AuthGuard to prevent logged-in users from accessing auth pages
  {
    path: "sign-up",
    component: CustomerSignUpComponent,
  },
  {
    path: "register",
    component: CustomerSignUpComponent,
  },
  {
    path: "faq",
    component: FaqComponent,
  },
  {
    path: "support",
    component: SupportComponent,
  },
  {
    path: "contact",
    component: ContactComponent,
  },
  {
    path: "login",
    component: CustomerLoginComponent,
  },
  {
    path: "verify-otp",
    component: VerifyOtpComponent,
  },
  // {
  //   path: "reset-password",
  //   component: CustomeResetPasswordComponent,
  // },
  { path: "request-demo", component: BusinessRequestDemoComponent },
  // {
  //   path: "business-login",
  //   component: BusinessLoginComponent,
  // },
  { path: "onboarding", component: BusinessOnboardingComponent },
  { path: "success", component: SuccessComponent },

  // Admin routes with AuthGuard (unchanged)
  {
    path: "admin/customer",
    component: CustomerComponent,
    canActivate: [AuthGuard],

    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "overview",
      },

      {
        path: "overview",
        component: CustomerOverviewComponent,
      },

      {
        path: "appointments",
        component: CustomerAppointmentsComponent,
      },

      {
        path: "appointment/details/:id",
        component: CustomerAppointmentDetailsComponent,
      },

      {
        path: "appointment/modify/:id",
        component: CustomerAppointmentModifyComponent,
      },

      {
        path: "salon/details/:id",
        component: CustomerSalonDetailsComponent,
      },

      {
        path: "favorites",
        component: CustomerFavoritesComponent,
      },

      {
        path: "promo-codes",
        component: CustomerPromoCodesComponent,
      },

      {
        path: "account",
        component: CustomerAccountSettingsComponent,
      },
    ],
  },
  {
    path: "admin/business",
    component: BusinessComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "overview",
      },
      { path: "overview", component: BusinessOverviewComponent },
      { path: "appointments", component: BusinessAppointmentsComponent },
      { path: "saloons", component: SalonsComponent },
      { path: "saloons/create", component: AddSalonFormComponent },
      { path: "saloons/edit/:id", component: AddSalonFormComponent },
      {
        path: "services",
        component: BusinessServicesMainComponent,
      },
      { path: "service/create", component: BusinessServiceCreateComponent },
      { path: "service/edit/:id", component: BusinessServiceCreateComponent },
      { path: "sales-finance", component: BusinessSalesFinancesComponent },
      {
        path: "customer-relationship",
        component: BusinessCustomerRelationshipComponent,
      },
      {
        path: "employee-management",
        component: BusinessEmployeeManagementComponent,
      },
      { path: "employee-management/create", component: AddEmployeeComponent },
      { path: "employee-management/edit/:id", component: AddEmployeeComponent },
      { path: "promotion", component: BusinessPromotionComponent },
      { path: "account", component: BusinessAccountStoreSettingsComponent },
    ],
  },
  {
    path: "admin/staff",
    component: StaffComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "overview",
      },
      { path: "overview", component: StaffOverviewComponent },
      { path: "appointment/add", component: BusinessAppointmentAddComponent },
      { path: "services", component: BusinessServicesMainComponent },
      {
        path: "customer-relationship",
        component: BusinessCustomerRelationshipComponent,
      },
      { path: "appointments", component: BusinessAppointmentsComponent },
    ],
  },
  // Platform Administration
  {
    path: "admin/platform",
    loadChildren: () =>
      import("./pages/platform-admin/platform-admin.routes").then(
        (m) => m.PLATFORM_ADMIN_ROUTES,
      ),
  },
  // 404 route stays EXACTLY the same
  {
    path: "404",
    component: NotFoundPageComponent,
    title: "404 Page Not Found",
  },
  {
    path: "**",
    redirectTo: "/404",
  },
];
